import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  Divider,
  Button
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const AttendanceReportCardView = ({ data, t , loggedUserId, onSearchChange, searchEnabled = false}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const itemsPerPage = 5;

  const handleTextChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    // Notifichiamo il padre così sa cosa mettere nel CSV se l'utente clicca Download
    if (onSearchChange) onSearchChange(value); 
  };

  // --- LOGICA DI FILTRO PRO ---
  const filteredData = data.filter((item) => {
    // 1. Se l'utente sta scrivendo nella barra di ricerca, filtra globalmente per nome
    if (searchTerm.trim().length > 0) {
      return item.userName?.toLowerCase().includes(searchTerm.toLowerCase());
    }
    
    // 2. Se la ricerca è vuota, mostra solo i dati dell'utente loggato
    return item.anaUserId === loggedUserId;
  });

  // Resetta pagina quando cambia filtro
  React.useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  if (!data || data.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography color="text.secondary">
          {t("Nessun dato disponibile") || "Nessun dato disponibile"}
        </Typography>
      </Box>
    );
  }

  /* Filtra i dati per nome utente
  const filteredData = data.filter((item) =>
    item.userName?.toLowerCase().includes(searchTerm.toLowerCase())
  );
*/
  const paginatedData = filteredData.slice(
    page * itemsPerPage,
    page * itemsPerPage + itemsPerPage
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  

  const parseTimeString = (timeStr) => {
    if (!timeStr) return { hours: 0, minutes: 0, seconds: 0 };
    const parts = timeStr.split(":");
    return {
      hours: parseInt(parts[0]) || 0,
      minutes: parseInt(parts[1]) || 0,
      seconds: parseInt(parts[2]) || 0,
    };
  };

  const formatTimeDisplay = (timeStr) => {
    if (!timeStr) return "-";
    return timeStr; // è già nel formato hh:mm:ss
  };

  return (
     <Box sx={{ 
              p: { xs: 0, sm: 2 },    // 0px mobile, 16px tablet+
              pt: { xs: 1, sm: 2 }     // 8px top mobile, 16px tablet+
            }}>
      {/* SEARCH BAR */}
      { searchEnabled && (
          <TextField
              size="small"
              fullWidth
              placeholder={t("Cerca") + "..."}
              value={searchTerm}
              /*onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(0);
              }}*/
              onChange={handleTextChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" color="action" />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />
      )}
      

      {/* CARD LIST */}
      {filteredData.length === 0 ? (
        <Box sx={{ textAlign: "center", p: 2 }}>
          <Typography color="text.secondary">
            {t("Nessun risultato trovato") || "Nessun risultato trovato"}
          </Typography>
        </Box>
      ) : (
        <>
          {paginatedData.map((item, idx) => (
            <Paper
              key={idx}
              sx={{
                p: { xs: 1.5, sm: 2.5 },      // 12px mobile, 20px tablet+
                mb: { xs: 1.5, sm: 2 },       // 12px mobile, 16px tablet+
                mx: { xs: 0.5, sm: 0 },       // 4px laterale mobile, 0 tablet+
                borderRadius: { xs: "8px", sm: "10px" },
                backgroundColor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
              }}
              elevation={0}
            >
              {/* Header: Nome Utente */}
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: "center" }}>
                <Typography variant="subtitle2" fontWeight="bold">
                  {item.userName || "-"}
                </Typography>
              </Box>

              <Divider sx={{ my: 1 }} />

              {/* Tempo Totale Presenze */}
              <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 1.5, mb: 1 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold">
                    {t("totalTimeSpent") || "Tempo Totale Presenze"}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "primary.main",
                      mt: 0.5,
                    }}
                  >
                    {formatTimeDisplay(item.hhmmss) || "-"}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          ))}

          {/* PAGINATION INFO */}
          {totalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 2 }}>
              <Typography variant="caption" color="text.secondary">
                {t("Pagina") || "Pagina"} {page + 1} {t("di") || "di"} {totalPages} | {filteredData.length}{" "}
                {t("risultati") || "risultati"}
              </Typography>
            </Box>
          )}

          {/* PAGINATION BUTTONS */}
          {totalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 2 }}>
              <Button
                 variant="outlined"  // ✅ Non più "contained"
                  color="primary"
                onClick={() => setPage(Math.max(0, page - 1))}
                disabled={page === 0}
               sx={{ fontWeight: 600 }}
              >
                {t("Precedente") || "Precedente"}
              </Button>
              <Button
                variant="outlined"      // ✅ Ancora meno invasivo
                color="primary"
                onClick={() => setPage(Math.min(totalPages - 1, page + 1))}
                disabled={page === totalPages - 1}
                
              >
                {t("Successivo") || "Successivo"}
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default AttendanceReportCardView;